import { FC } from "react";

import Image, { ICONS } from "../Image";

import { StyledErrorLabel } from "../Flex";

import { useMediaQuery } from "context/media/MediaContext";

import { StyledOuterContainer } from "./Error.styles";

interface ErrorProps {
  error: string;
  fontSize?: string;
  isWhite?: boolean;
}

const Error: FC<ErrorProps> = ({
  error,
  fontSize = "16px",
  isWhite = false,
}) => {
  const { isMobile } = useMediaQuery();

  return (
    <StyledOuterContainer>
      {error && (
        <>
          <Image
            alt='Error Icon'
            height='28px'
            srcSet={ICONS.ERROR}
            width='28px'
          />

          <StyledErrorLabel
            fontSize={fontSize}
            top={isMobile ? "7px" : "8px"}
            isWhite={isWhite}
          >
            {error}
          </StyledErrorLabel>
        </>
      )}
    </StyledOuterContainer>
  );
};

export default Error;
